<template>
  <div class="flex_vh100 home">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
      </van-nav-bar>
    </div>
    <div
      v-for="(group, gIdx) in menuGroups"
      :key="gIdx"
      class="vertical-menu-list"
    >
      <div v-for="(item, idx) in group" :key="idx">
        <van-cell
          :title="item.newTitle"
          :icon="item.icon"
          is-link
          @click="onMenuClick(item)"
        >
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import menuJson from "../config/menu.json";
import { GetMenuList } from "../api/menuapi.js";
export default {
  name: "SecondMenu",
  data() {
    return {
      title: "",
      menuId: "",

      menuList: [],
    };
  },
  watch: {
    $route(to) {
      // 路由变化时更新激活的标签
      if (to.name == "SecondMenu") {
      }
    },
  },
  computed: {
    //按 group 字段分组渲染，无 group 的归为同一组，组与组之间隔开
    menuGroups() {
      var groups = [];
      this.menuList.forEach((item) => {
        var groupNo = item.group || 1;
        var target = groups.find((g) => g.no == groupNo);
        if (!target) {
          target = { no: groupNo, list: [] };
          groups.push(target);
        }
        target.list.push(item);
      });
      groups.sort((a, b) => a.no - b.no);
      return groups.map((g) => g.list);
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1); // 后退一步
    },
    //解析菜单
    async parseMenu() {
      var adminMenu = [];
      var menuApi = await this._getMenuList();
      menuApi.forEach((item) => {
        adminMenu = [...adminMenu, ...item.routes];
      });

      var menuList = [];
      var firstMenu = menuJson.filter((e) => {
        return e.newTitle == this.title;
      });
      if (firstMenu.length == 0) {
        this.menuList = [];
        return;
      }

      firstMenu[0].child.forEach((item) => {
        var menuItem = adminMenu.filter((e) => {
          // 权限求交集
          const setB = new Set(e.rightCodeList);
          const intersection = item.right.filter((x) => setB.has(x));

          return e.name == item.title && intersection.length > 0;
        });
        if (menuItem.length > 0) {
          menuList.push(Object.assign({}, item, {
            rightCodeList: menuItem[0].rightCodeList,
          }));
        }
      });

      this.menuList = menuList;
    },

    onMenuClick(item) {
      this.$router.push({
        name: item.pageName,
        query: {
          rightCode: (item.rightCodeList || []).join(","),
        },
      });
    },

    //获取菜单列表
    _getMenuList() {
      var par = {
        FatherMenuId: this.menuId,
      };
      return GetMenuList(par);
    },
  },
  mounted() {
    this.title = this.$route.query.title;
    this.menuId = this.$route.query.menuId;
    this.parseMenu();
  },
};
</script>

<style scoped>
.vertical-menu-list {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin: 12px;
}
/* 组与组之间额外隔开 */
.vertical-menu-list + .vertical-menu-list {
  margin-top: 8px;
}
/* 自定义菜单值样式 */
.menu-value {
  color: #969799;
  font-size: 14px;
}

/* 分割线样式 */
::v-deep .van-cell:not(:last-child) {
  border-bottom: 1px solid #ebedf0;
}

/* 菜单项悬停效果（适用于PC端） */
::v-deep .van-cell:active {
  background: #f2f3f5;
  transition: all 0.2s ease;
}

/* 自定义图标颜色 */
::v-deep .van-cell__left-icon {
  color: #1677ff;
  font-size: 20px;
}

/* 标题字体 */
::v-deep .van-cell__title {
  font-size: 15px;
  font-weight: 400;
}

/* 描述文字样式 */
::v-deep .van-cell__label {
  font-size: 12px;
  color: #969799;
  margin-top: 4px;
}
</style>